import { AbstractSelfAccountKeyring } from '../keyring/account_base';
import { AccountSignatureConfigDumpArgs } from '../context/account_signature/args';
import { ACCOUNT_SIGNATURE_CRYPTO_CONTEXT } from '../context/account_signature/__init__';
import { concatByteArray } from '../utility';

export const SERVER_DELETE_CHALLENGE_RESPONSE_PREFIX = new Uint8Array([
  115, 101, 114, 118, 101, 114, 45, 100, 101, 108, 101, 116, 101, 45, 99, 104, 97, 108, 108, 101,
  110, 103, 101, 58,
]);

/**
 * Sign the request-challenge payload for account deletion.
 */
export function create_account_delete_request(
  self_kr: AbstractSelfAccountKeyring,
  delete_token: Uint8Array
): Promise<Object> {
  delete_token = concatByteArray(SERVER_DELETE_CHALLENGE_RESPONSE_PREFIX, delete_token);
  return ACCOUNT_SIGNATURE_CRYPTO_CONTEXT.dump(
    new AccountSignatureConfigDumpArgs(delete_token, self_kr)
  ).then((signature) => {
    return {
      deleteToken: delete_token,
      signature,
    };
  });
}
